module.exports = __webpack_public_path__ + "img/connection-left-1.46253ae5.png";